<div class="modal" (click)="clickOuside()">
    <div class="modal-content" (click)="stopPropagation($event)">
        <div class="modal-header"> {{ header }} </div>
        <div class="modal-body">
            <div class="msg-wrapper">{{ msg }}</div>
            <div class="list-wrapper">
                <div class="list" *ngFor="let item of list" [innerHTML]="item"></div>
            </div>
            <div class="button-wrapper">
                <frg-button (activated)="confirmAction()">Oui</frg-button>
                <frg-button backgroundColor="var(--darkest-primary)" (activated)="closeConfirmationModal()">Non
                </frg-button>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>